import gql from "graphql-tag";
import { IContent } from "@/models/Content.model";

export const allContent = () => {
  return gql`
    query allContent($conference: ID!) {
      allContent(conference: $conference) {
        _id
        section
        title
        subtitle
        text
        textarea1
        textarea2
        textarea3
        textarea4
        note
        link
        links
        table {
          parts {
            header
            rows {
              participantType
              beforeDeadline
              afterDeadline
            }
          }
        }
        dates {
          _id
          date
          title
        }
      }
    }
  `;
};

export const updateContent = (content: IContent) => {
  return gql`mutation {updateContent( conference:"${content.conference}",
    section:"${content.section}",
  title:"${content.title}",
  subtitle:"${content.subtitle}",
  text:"${content.text}",
  textarea1:"${content.textarea1}",
  textarea2:"${content.textarea2}",
  textarea3:"${content.textarea3}",
  textarea4:"${content.textarea4}",
  note:"${content.note}",
  link:"${content.link}",
  ${
    content.dates && content.dates.length > 0
      ? `dates:[${content.dates?.map(
          (date) =>
            `{_id: "${date._id}" , date: "${date.date}" , title: "${date.title}"}`
        )}],`
      : ""
  }
  ${
    content.table && content.table.parts.length > 0
      ? `table:
  {parts:[${content.table.parts.map(
    (part) =>
      `{header:"${part.header}",
          rows:[${part.rows.map(
            (row) =>
              `{participantType: "${row.participantType}", beforeDeadline: "${row.beforeDeadline}", afterDeadline: "${row.afterDeadline}"}`
          )}]
        }`
  )}]
  }`
      : ""
  }){
    ${`
    _id
    conference
    section
    title
    subtitle
    text
    textarea1
    textarea2
    textarea3
    textarea4
    note
    link
    links
    table{
      parts{
        header
        rows {
          participantType
          beforeDeadline
          afterDeadline
        }
      }
    }
    dates{
      _id
      date
      title
    }
    `}
  }}`;
};
